import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { proposalPath, workOrderPath } from 'routes';
import { Dialog } from '@progress/kendo-react-dialogs';
import I18n, { translate } from '@utils/i18n';
import './NumberCell.scss';

const namespace = 'features.proposals.index.number_cell';

function NumberCell({ dataItem, colSpan, className, ariaColumnIndex, style }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleDialog = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected="false"
      style={style}>
      <a href={proposalPath(dataItem.id)}>{dataItem.number}</a>

      {dataItem.workOrders.length > 0 && (
        <>
          <br />
          <button type="button" className="qmb-button--link" onClick={toggleDialog}>
            (WO#s)
          </button>
        </>
      )}

      {isModalOpen && (
        <Dialog
          width={450}
          minHeight={192}
          title={translate('title', { namespace })}
          className="qmb-dialog"
          onClose={toggleDialog}>
          {dataItem.workOrders.map(([id, woNumber]) => (
            <span className="qmb-button ml-2 mb-2" key={id}>
              <a href={workOrderPath(id)} target="_blank" rel="noopener noreferrer">
                {woNumber}
              </a>
            </span>
          ))}
          <div className="modal__footer mt-5 pull-right" style={{ justifyContent: 'space-between' }}>
            <div className="mt-3">
              <button type="button" className="qmb-button" onClick={toggleDialog}>
                {I18n.t('generic.close')}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </td>
  );
}

NumberCell.propTypes = {
  dataItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    number: PropTypes.number.isRequired,
    workOrders: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])))
  }).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  colSpan: PropTypes.number.isRequired,
  ariaColumnIndex: PropTypes.number.isRequired
};

NumberCell.defaultProps = {
  className: '',
  style: {}
};

export default NumberCell;
